import React, {useContext, useEffect, useState, useRef} from "react";
import SlotsProviders from "../../Service/SlotsProviders";
import Spin from "../../../../components/UI/Spin/Spin";
import styles from "./pageGameSlot.module.css"
import {useNavigate, useParams} from 'react-router-dom';
import ErrorComponent from "../../../../components/UI/Error/ErrorComponent";
import {Context} from "../../../../index";
import {NAME_SERVER} from "../../../../Utils/NAME_HOST";
import Footer from "../../../../components/Footer/Footer";
import {fillTextPage} from "../../../../Utils/FillTextPage";
import axios from "axios";
import BackButton from "../../../../components/UI/BackButton/BackButton";
import UserService from "../../../../service/UserService";
import ToolsAround from "../../../../components/UI/ToolsAround/ToolsAround";

function PageGameSlot() {
    const {store} = useContext(Context)
    const navigate = useNavigate();
    const [link_navigateBack, setLinkNavigateBack] = useState("")
    const {gameData} = useParams()
    const [imgGame, setImgGame] = useState("")
    const [nameGame, setNameGame] = useState("")
    const iframeRef = useRef(null);

    const scollToRef = useRef();

    const [isLoading, setIsLoading] = useState(true);
    const [loadingResources, setIsLoadingResources] = useState(true)
    const [launchUrl, setLaunchUrl] = useState("")
    const [intervalState, setIntervalState] = useState(null)
    // function setSize(){
    //     const iframe =document.querySelector("iframe")
    //     const containerFrame = document.querySelector("#containerFrame")
    //     console.log(iframe,document.documentElement.clientHeight)
    //     containerFrame.style.height = document.documentElement.clientHeight
    //     iframe.height = document.documentElement.clientHeight
    //     iframe.style.height = document.documentElement.clientHeight;
    //     containerFrame.style.width = document.documentElement.clientWidth
    //     iframe.width = document.documentElement.clientWidth
    //     iframe.style.width = document.documentElement.clientWidth;
    // }


    async function getUrlGame() {
        try {

            const [uuid, mode] = gameData.split("_")

            const response = await SlotsProviders.getGameUrl(
                uuid, mode
            );


            if (response.data.status === 0) {
                store.add_message(response.data.msg, ErrorComponent)
            } else if (response.data.redirect) {
                navigate(response.data.redirect)
            } else {

                if (response.data.category_games === "LD") {
                    setLinkNavigateBack("/live_dealers")
                } else {
                    setLinkNavigateBack("/slots")

                }
                setLaunchUrl(response.data.launchUrl)
                setImgGame(response.data.img_game)
                setNameGame(response.data.name_game)

                setIsLoading(false);
                store.setIsLoadingComponent(false)
                const int = setInterval(() => {
                    updateBalance()
                }, 1000)
                setIntervalState(int)
                

            }


        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
            store.setIsLoadingComponent(false)

        }
    }

    async function updateBalance() {
        const response = await UserService.getBalance()
        if (response.data.status === 1) {
            store.user.balance = response.data.balance;
            store.user.freespins = response.data.freespin
            store.user.balance_casino = response.data.balance_bonus
        } else {
            clearInterval(intervalState)
        }
    }

    const handleFullscreen = () => {
        const iframe = iframeRef.current;
        if (iframe.requestFullscreen) {
            iframe.requestFullscreen();
        } else if (iframe.mozRequestFullScreen) { // Firefox
            iframe.mozRequestFullScreen();
        } else if (iframe.webkitRequestFullscreen) { // Chrome, Safari and Opera
            iframe.webkitRequestFullscreen();
        } else if (iframe.msRequestFullscreen) { // IE/Edge
            iframe.msRequestFullscreen();
        }
    };

    useEffect(() => {
        fillTextPage("gameSlotIgrator", store)
        getUrlGame();


        return () => {
            clearInterval(intervalState)
        }

    }, []);


    if (isLoading) {
        return <Spin/>;
    }

    return (
        <>
            <div className={`${styles.mainContainer} fadeAnimationMain`} style={{
                marginTop: store.isPhone ? 60 : 30 + "px"
            }}>
                <div className={styles.containerTools}>
                    <ToolsAround onClick={() => navigate(link_navigateBack)} element={
                        <i className="fa-solid fa-arrow-left"></i>
                    }/>
                    {!store.isPhone && (
                        <ToolsAround onClick={handleFullscreen} element={
                            <i className="fa-solid fa-expand"></i>

                        }/>
                    )}


                </div>

                {/*{store.isPhone && (*/}
                {/*    <div style={{position: "absolute", padding: "10px"}}>*/}
                {/*        <BackButton onClick={() => navigate(link_navigateBack)}/>*/}

                {/*    </div>*/}

                {/*)}*/}

                <div ref={scollToRef} style={{
                    height: (window.innerHeight - (store.isPhone ? 120 : 0)) + "px"
                }} className={styles.containerIframe} id="containerFrame">

                    {loadingResources && (<Spin/>)}
                    <iframe
                        onLoad={() => setIsLoadingResources(false)}
                        className={loadingResources ? styles.disable : "fadeAnimationMain"}
                        src={launchUrl}
                        title={nameGame}
                        width="100%"
                        height="100%"
                        frameBorder={0}
                        allowFullScreen
                        ref={iframeRef}

                    />
                </div>
            </div>
            <div className={styles.bottom_dop}>
                <Footer/>
            </div>

        </>
    )
        ;
}

export default PageGameSlot;
